import NewCountryPicker, {
    NewCountryPickerFill,
} from 'components/NewCountryPicker/NewCountryPicker';
import { MultiCountryPickerPreview } from 'components/Pickers/MultiCountryPickerPreview';
import PickerToggler from 'components/Pickers/PickerToggler';
import { IActiveCountry, IActiveGroup, IActiveCountryMap } from 'interfaces';
import { get, flow, find, forEach } from 'lodash/fp';
import { inject } from 'mobx-react';
import { IMobxRootState } from 'RootStore';
import { usePopupTopOffset } from 'hooks/usePopupTopOffset';

type Props = {
    licensedCountriesArr?: IActiveCountry[];
    selectedCountries: number[];
    groups?: IActiveGroup[];
    countries?: IActiveCountryMap;
    removeCountry: (countryId: number) => void;
    addCountry: (countryId: number) => void;
    toggleCountry: (countryId: number) => void;
};

const FeedCountryFilter = inject(
    ({ countryStore, settingsStore, heatmapStore }: IMobxRootState) => {
        return {
            licensedCountriesArr: countryStore.countries.licensedCountriesArr,
            groups: settingsStore.activeGroups,
            countries: countryStore.countries.countries,
            heatmapCountries: heatmapStore.countriesList,
        };
    }
)((props: Props) => {
    const {
        licensedCountriesArr,
        groups,
        selectedCountries,
        removeCountry,
        addCountry,
        toggleCountry,
    } = props;
    const [togglerRef, popupTop] = usePopupTopOffset();

    return (
        <div ref={togglerRef} data-testid="feed-country-filter">
            <PickerToggler
                labelComponent={
                    <MultiCountryPickerPreview
                        selectedCountries={selectedCountries}
                        onCountryClick={countryId => {
                            toggleCountry(countryId);
                        }}
                    />
                }
                icon="Globe">
                <NewCountryPickerFill top={popupTop}>
                    <NewCountryPicker
                        canSelectAllCountries={false}
                        countriesList={licensedCountriesArr}
                        selectedCountriesList={selectedCountries}
                        groups={groups}
                        isMultiSelect={true}
                        onCountrySelected={(countryId: number) => {
                            toggleCountry(countryId);
                        }}
                        onAllUnselected={(id: string) => {
                            //todo: refactor activeGroupCountries into a function
                            const activeGroupCountries = flow(
                                find((group: IActiveGroup) => group.id == id),
                                get('countries')
                            )(groups);
                            forEach(
                                countryId => removeCountry(countryId),
                                activeGroupCountries
                            );
                        }}
                        onAllSelected={id => {
                            const activeGroupCountries = flow(
                                find((group: IActiveGroup) => group.id == id),
                                get('countries')
                            )(groups);
                            forEach(
                                countryId => addCountry(countryId),
                                activeGroupCountries
                            );
                        }}
                    />
                </NewCountryPickerFill>
            </PickerToggler>
        </div>
    );
});

export default FeedCountryFilter;
